import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: "/",
        redirect: "/DZHChat",
    },
    {
        path: '/DZHChat',
        component: () => import("./views/wpsEditor.vue"),
        meta: {title: "智能报告写作"}
    },
    {
        name: '404',
        path : '/404',
        component: () => import("./views/404.vue"),
        meta: {title: "页面找不到了"}
    },
    {
        path : '*',
        redirect: {
            name: 404
        },
    }
]
const router = new Router({
    mode: 'history',
    routes
});

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    document.title = `${to.meta.title}`;
    next();
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router;
